/* ==========================================================================
   BAAGHI — wishlist.js
   Lightweight localStorage wishlist (no app, no login required)
   ========================================================================== */
(function () {
  'use strict';

  const KEY = 'baaghi:wishlist';
  const strings = (window.BAAGHI && window.BAAGHI.strings) || {};

  function read() {
    try {
      const raw = localStorage.getItem(KEY);
      const list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? [...new Set(list.filter((handle) => typeof handle === 'string' && handle))] : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable */
    }
    document.dispatchEvent(new CustomEvent('baaghi:wishlist:change', { detail: { list } }));
  }

  const Wishlist = {
    all: read,
    has(handle) {
      return read().indexOf(handle) > -1;
    },
    toggle(handle) {
      const list = read();
      const index = list.indexOf(handle);
      if (index > -1) list.splice(index, 1);
      else list.unshift(handle);
      write(list);
      return index === -1;
    },
    remove(handle) {
      const list = read().filter((item) => item !== handle);
      write(list);
    }
  };
  window.BAAGHI.Wishlist = Wishlist;

  function paint(scope) {
    const list = read();
    (scope || document).querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const active = list.indexOf(btn.getAttribute('data-wishlist-toggle')) > -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
      btn.setAttribute('aria-label', active ? strings.wishlistRemove : strings.wishlistAdd);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((node) => {
      node.textContent = list.length;
      node.hidden = list.length === 0;
    });
    document.querySelectorAll('[data-wishlist-summary]').forEach((node) => {
      const template = list.length === 1 ? node.dataset.one : node.dataset.other;
      node.textContent = (template || '').replace('__COUNT__', String(list.length));
    });
    document.querySelectorAll('[data-wishlist-clear]').forEach((node) => {
      node.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', (event) => {
    const clear = event.target.closest('[data-wishlist-clear]');
    if (clear) {
      write([]);
      return;
    }

    const btn = event.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    const added = Wishlist.toggle(btn.getAttribute('data-wishlist-toggle'));
    paint();
    window.BAAGHI.toast(added ? strings.wishlistAdd : strings.wishlistRemove);
  });

  /* ── Wishlist page rendering ──────────────────────────────────────────── */

  function renderWishlistPage() {
    const container = document.querySelector('[data-wishlist-grid]');
    if (!container) return;
    const empty = document.querySelector('[data-wishlist-empty]');
    const error = document.querySelector('[data-wishlist-error]');
    const handles = read();

    if (error) error.hidden = true;
    paint();
    if (!handles.length) {
      container.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    container.innerHTML = '<div style="grid-column:1/-1;display:grid;place-items:center;min-height:180px"><span class="spinner"></span></div>';

    Promise.all(
      handles.map((handle) =>
        fetch(`${window.BAAGHI.routes.root}products/${handle}?section_id=product-card-ajax`)
          .then((res) => ({ handle, status: res.status, text: res.ok ? res.text() : Promise.resolve('') }))
          .then(async (result) => ({ ...result, text: await result.text }))
          .catch(() => ({ handle, status: 0, text: '' }))
      )
    ).then((results) => {
      const staleHandles = [];
      const markup = results
        .map((result) => {
          if (!result.text) {
            if (result.status === 404) staleHandles.push(result.handle);
            return '';
          }
          const doc = new DOMParser().parseFromString(result.text, 'text/html');
          const card = doc.querySelector('[data-card-inner]');
          const returnedHandle = card?.querySelector('[data-wishlist-toggle]')?.getAttribute('data-wishlist-toggle');
          if (!card || returnedHandle !== result.handle) {
            staleHandles.push(result.handle);
            return '';
          }
          return card.outerHTML;
        })
        .join('');
      const hasTemporaryFailure = results.some((result) => result.status === 0 || result.status >= 500);
      if (staleHandles.length) {
        write(handles.filter((handle) => !staleHandles.includes(handle)));
        return;
      }
      container.innerHTML = markup;
      if (!markup && !hasTemporaryFailure) {
        if (empty) empty.hidden = false;
      }
      if (error) error.hidden = !hasTemporaryFailure;
      paint(container);
      if (window.BAAGHI.observeReveals) window.BAAGHI.observeReveals(container);
    });
  }

  document.addEventListener('baaghi:wishlist:change', () => {
    if (document.querySelector('[data-wishlist-grid]')) renderWishlistPage();
  });

  paint();
  renderWishlistPage();
})();
